export default __webpack_public_path__ + "static/media/finlist-low-turnover.237ce95b.png";